<template>
  <div class="chart-container">
    <apexchart 
      type="bar"
      :height="chartHeight"
      :options="apexOptions"
      :series="apexSeries"
    />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ClientTeusAllClientsChart',
  
  components: {
    apexchart: VueApexCharts
  },
  
  props: {
    chartData: {
      type: Object,
      required: true
    },
    chartHeight: {
      type: Number,
      default: 400
    }
  },

  computed: {
    apexSeries() {
      if (!this.chartData || !this.chartData.datasets || !this.chartData.datasets[0]) {
        return []
      }
      
      return [{
        name: this.chartData.datasets[0].label || 'Total TEUs',
        data: this.chartData.datasets[0].data || []
      }]
    },
    
    apexOptions() {
      return {
        chart: {
          type: 'bar',
          toolbar: {
            show: true,
            tools: {
              download: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true
            }
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '60%',
            distributed: true,
            borderRadius: 4,
            dataLabels: {
              position: 'top'
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val + ' TEUs'
          },
          offsetX: 0,
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758']
          }
        },
        stroke: {
          show: true,
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: this.chartData.labels || [],
          labels: {
            style: {
              fontSize: '11px'
            },
            formatter: function(value) {
              // Truncate long client names
              if (value.length > 20) {
                return value.substring(0, 20) + '...'
              }
              return value
            }
          },
          title: {
            text: 'Total TEUs',
            style: {
              fontSize: '14px',
              fontWeight: 'bold'
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              fontSize: '11px'
            }
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + ' TEUs'
            }
          }
        },
        colors: [
          '#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', 
          '#546E7A', '#26a69a', '#D10CE8', '#FF6B6B', '#4ECDC4',
          '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD', '#98D8C8',
          '#F7DC6F', '#BB8FCE', '#85C1E9', '#F8C471', '#82E0AA'
        ],
        legend: {
          show: false
        },
        grid: {
          borderColor: '#e7e7e7',
          strokeDashArray: 3
        }
      }
    }
  }
}
</script>

<style scoped>
.chart-container {
  position: relative;
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
</style>



// WEBPACK FOOTER //
// ClientTeusAllClientsChart.vue?30600c53